import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as moment from "moment";
import {ActivatedRoute, Router} from "@angular/router";
import axios, {AxiosInstance, AxiosResponse} from "axios";
import {APIResponse, icJWT_Account} from "../NIBINInterface";
import {ChangeDetection} from "@angular/cli/lib/config/workspace-schema";

@Injectable()
export class AuthService {
  constructor(private route: ActivatedRoute, private router: Router) {}

  public login(empID:string, dept:string, otp:string): void {
    localStorage.removeItem("id_token");

     axios.post('/NIBIN/Auth', {empID:empID, dept:dept, otp:otp},{ headers:{}})
      .then((result)=>{
        let apiToken: string = result.data //jwt key from IC WEBAPI Server
        let apiToken_User = JSON.parse(atob(apiToken.split('.')[1])) //get the 1 from a [0].[1].[3] token (jwt)

        try{
          let user: icJWT_Account = <icJWT_Account>{
            apikey: apiToken,
            empID: apiToken_User.empID,
            Dept: apiToken_User.Dept,
            CurrentDept: apiToken_User.Dept,
            DeptORI: apiToken_User.DeptORI,
            FirstName: apiToken_User.FirstName,
            LastName: apiToken_User.LastName,
            AuthLevel: apiToken_User.AuthLevel,
            EmailID: apiToken_User.EmailID,
            Phone: apiToken_User.Phone,
            eOTP: apiToken_User.eOTP,
            OTHER_DEPTS: (apiToken_User.OTHER_DEPTS) ? apiToken_User.OTHER_DEPTS?.toLowerCase().split(',') : [],
            isSuperAdmin: apiToken_User.isSuperAdmin,
            token_expire: apiToken_User.exp
          }

          localStorage.setItem("id_token",btoa(<string>JSON.stringify(user)))
          this.router.navigateByUrl('/dashboard')
        }catch (e) {

        }
    }).catch((e) =>{

       this.router.navigateByUrl('/auth')
    });
  }

  public logout() {
    localStorage.removeItem("id_token");
    this.router.navigateByUrl('/')
  }

  public isLoggedIn() : boolean {
    let user: icJWT_Account = this.getUser()

    return !!user;

  }

  //force a reload when switching departments
  private reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  public switchDept(newDept:string): void{
    let user = this.getUser()
    user.CurrentDept = newDept
    localStorage.setItem("id_token",btoa(<string>JSON.stringify(user)))

    this.reloadCurrentRoute()

  }

  public getUser(): icJWT_Account{
    let user: icJWT_Account = <icJWT_Account> {}
    let user_store = localStorage.getItem('id_token')

    if(user_store){
      user = <icJWT_Account>JSON.parse(atob(user_store))
      //logout if token_expire is not a valid integer
      if(isNaN(Number(user.token_expire) ))
        this.logout()
      //logout if token is expired
      if(!(moment( Number(user.token_expire) * 1000).isAfter(Date.now())))
        this.logout()
    }
    else
      this.logout()

    return user; // will return {} if not logged in and will be redirected to login page
  }

  public authenticatedApi(): AxiosInstance{
    let user : icJWT_Account = this.getUser()
    return axios.create({
      timeout:1000,
      headers:{
        "Authorization":user.apikey
      }
    })
  }

  public async GetNIBINDashboardURL() : Promise<string | null> {
    try{
      let result = await axios.get('/NIBIN/Report/GetDashboardReportURL',{headers:{authToken:this.getUser().apikey}})
      let apiResult:APIResponse = result.data

      if(apiResult.MessageCode==200){
        return apiResult.AnyData;
      }

      return null;
    }
    catch (e) {
      return null
    }

  }


}
